import styled from '@emotion/styled'

export const StyledMain = styled.main`
  height: 100%;
  min-height: 100vh;
  position: relative;
`
